export default __webpack_public_path__ + "static/media/29_whale.4b424afa.JPG";